import { Loader2 } from "lucide-react";

export function Loading({ text = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-10 gap-2" data-testid="loading-spinner">
      <Loader2 className="h-8 w-8 animate-spin text-cyan-600" />
      <p className="text-sm text-muted-foreground">{text}</p>
    </div>
  );
}
